<template>
    <v-container  grid-list-xs>
        <v-row align="center" justify="center" class="mt-4">
            <v-col cols="12" xl="8" lg="8" class="text-center">
               <h1> <p> ¿Cómo participar? </p></h1>
            </v-col>
            </v-row>
        <v-row align="center" justify="center" >
            <v-col cols="12" xl="6" lg="6" class="text-justify">
                <h3> <p> 1. Regístrate en la <a @click="cambiarVista()"> sección de inscripción </a> de este sitio</p></h3>
                <h3> <p> 2. Imprime tu ficha de participación</p></h3>
                <h3> <p> 3. Prepárate para el examen</p></h3>
                <h3> <p> 4. Preséntate en la sede elegida con tu ficha de participación el día del examen</p></h3>
            </v-col>
        </v-row>

    </v-container>  
</template>

<script>
export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Participa - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
  }
  },
    methods:{
        cambiarVista() {  
            this.$router.push("/participa/inscripcion")

        },
    }

}
</script>

<style>

</style>